import { z } from 'zod';

export const ClientStatusSchema = z.enum(['activo', 'mora', 'inactivo']);
export type ClientStatus = z.infer<typeof ClientStatusSchema>;

export const PaymentMethodSchema = z.enum([
  'transferencia',
  'domiciliacion',
  'tarjeta',
  'confirming',
  'efectivo',
  'otro',
]);
export type PaymentMethod = z.infer<typeof PaymentMethodSchema>;

// SEPA direct-debit scheme codes: CORE (general/consumer) or B2B (business).
export const SepaSchemeSchema = z.enum(['CORE', 'B2B']);
export type SepaScheme = z.infer<typeof SepaSchemeSchema>;

export const CreateClientSchema = z.object({
  name: z.string().min(1),
  nif: z.string().min(1),
  ownerId: z.string().uuid().optional(),
  status: ClientStatusSchema.default('activo'),
  email: z.string().email().nullish(),
  phone: z.string().nullish(),
  address: z.string().nullish(),
  city: z.string().nullish(),
  postalCode: z.string().nullish(),
  country: z.string().nullish(),
  paymentMethod: PaymentMethodSchema.nullish(),
  iban: z.string().nullish(),
  bic: z.string().nullish(),
  bankName: z.string().nullish(),
  accountHolder: z.string().nullish(),
  sepaMandateRef: z.string().nullish(),
  sepaMandateDate: z.string().nullish(),
  sepaScheme: SepaSchemeSchema.nullish(),
  paymentTermsDays: z.number().int().min(0).max(365).default(30),
  creditLimit: z.number().min(0).default(0),
});
export type CreateClientRequest = z.infer<typeof CreateClientSchema>;

export const UpdateClientSchema = CreateClientSchema.partial();
export type UpdateClientRequest = z.infer<typeof UpdateClientSchema>;
